import { omit } from '@sama/micro-dash';
import {
  Tracker,
  TrackingEvent,
} from '../../cross-team-shared/event-tracking/event-utils';
import { EventTrackingOptions } from '../../team-apis/core/event-tracking';

export class ConsoleTracker implements Tracker {
  track(event: TrackingEvent, options?: EventTrackingOptions) {
    // eslint-disable-next-line no-console -- Using debug to avoid polluting the console
    console.debug('Event:', event.id, omit(event, 'id'), options);
  }
}
